export default [
  {
    title: 'All threads',
    to: 'scheduled-threads',
    permissions: [{
      subject: 'thread',
      actions: ['view-nav-link'],
    },],
  },
  {
    title: 'Threads timed for Today',
    to: 'scheduled-threads-today',
    permissions: [{
      subject: 'thread',
      actions: ['view-nav-link'],
    },],
  },
];
